import { ArrowDropDown, ArrowDropUp, Check } from '@mui/icons-material';
import { Typography, styled, Button, MenuList, MenuItem } from '@mui/material';
import { Column } from 'components/Layout';
import { useLayoutContext } from 'contexts/LayoutContext';
import { useState } from 'react';

const SwitcherHandle = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(theme.spacingSizes.xs, theme.spacingSizes.sm),
  outline: `1px solid ${theme.palette.grey[300]}`,

  '&:hover': {
    outline: `1px solid ${theme.palette.grey[400]}`,
  },
}));

const VehicleList = styled(MenuList)(({ theme }) => ({
  padding: theme.spacing(2, 2),
  gap: theme.spacing(theme.spacingSizes.xs),
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '270px',
  overflowY: 'auto',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
}));

const VehicleOption = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(theme.spacingSizes.xs, 0),
  borderRadius: theme.shape.borderRadius,
}));

const VehicleLabel = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightRegular,
}));

type Props = {
  onVehicleChange: () => void;
  useExpandedState: boolean;
};

const VehicleSwitcher: React.FC<Props> = ({
  onVehicleChange,
  useExpandedState = false,
}) => {
  const [isOpen, setIsOpen] = useState(useExpandedState);
  const { availableVehicles, vehicle, switchVehicle, selectedVehicleId } =
    useLayoutContext();

  const vehicles = availableVehicles.map((vehicle) => ({
    value: vehicle._id,
    label: vehicle.vehicleName,
  }));
  return (
    <Column spacing="sm">
      {!useExpandedState ? (
        <SwitcherHandle
          variant="text"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <VehicleLabel variant="h6" color="text.primary" lineHeight="16px">
            {vehicle?.vehicleName}
          </VehicleLabel>
          {isOpen ? (
            <ArrowDropUp color="action" />
          ) : (
            <ArrowDropDown color="action" />
          )}
        </SwitcherHandle>
      ) : null}
      {isOpen ? (
        <VehicleList>
          {vehicles.map((vehicle) => (
            <VehicleOption
              key={vehicle.value}
              onClick={() => {
                switchVehicle(vehicle.value);
                setIsOpen(false);
                onVehicleChange();
              }}
            >
              <VehicleLabel variant="body2" color="text.primary">
                {vehicle.label}
              </VehicleLabel>
              {vehicle.value && vehicle.value === selectedVehicleId ? (
                <Check fontSize="small" color="action" />
              ) : null}
            </VehicleOption>
          ))}
        </VehicleList>
      ) : null}
    </Column>
  );
};

export default VehicleSwitcher;
